import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import locale files
import enLocale from './locales/en.json';
import esLocale from './locales/es.json';
import frLocale from './locales/fr.json';
import nlLocale from './locales/nl.json';

// Configure i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enLocale
      },
      es: {
        translation: esLocale
      },
      fr: {
        translation: frLocale
      },
      nl: {
        translation: nlLocale
      }
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // Not needed for React as it escapes by default
    },
    
    react: {
      useSuspense: false, // Disable suspense to prevent loading states
    },
    
    // Options for language detection
    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'navigator', 'cookie'],
      
      // Keys or params to lookup language from
      lookupLocalStorage: 'language',
      lookupCookie: 'i18next',
      
      // Cache user language in browser
      caches: ['localStorage', 'cookie'],
      
      // Expire user language cache
      cookieExpirationDate: new Date(Date.now() + 2 * 365 * 24 * 60 * 60 * 1000) // 2 years
    }
  });

export default i18n;